import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.server.auth.details;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'SERVER_AUTH_DETAILS',
	method: 'POST',
	url: '/server/auth/details.json',
});

export { actions, reducer, sagas, selectors };
